module.exports = __webpack_public_path__ + "img/Dilo Cargo SVG.289f06b6.svg";